import { t } from '@hefe/i18n';
import { LoadingStatus, loginUser, userState } from '@hefe/store';
import { Col, Row } from 'antd';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import bannerWhite from '../../../../assets/images/logo/banner_white.png';
import CustomForm, {
  FormField,
} from '../../../containers/core/components/form/custom-form';
import { useAppDispatch } from '../../../store/store';
import styles from './login.page.module.scss';

/* eslint-disable-next-line */
export interface LoginProps {}

export function LoginPage(props: LoginProps) {
  const dispatch = useAppDispatch();
  const stateUser = useSelector(userState);
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleLogin = async (values: any) => {
    dispatch(loginUser(values))
      .unwrap()
      .then((result) => {
        if (state?.redirectUrl) {
          navigate(state?.redirectUrl);
        } else {
          navigate('/');
        }
      });
  };

  const fields: FormField[] = [
    {
      name: 'email',
      type: 'email',
      label: '',
      placeholder: t('email'),
      rules: [
        {
          required: true,
          type: 'email',
          message: t('form_errors.email'),
        },
      ],
    },
    {
      name: 'password',
      type: 'password',
      label: '',
      placeholder: t('password'),
      rules: [
        {
          required: true,
          type: 'string',
          message: t('form_errors.password'),
        },
      ],
    },
  ];

  return (
    <div className={styles['container']}>
      <Row align="middle">
        <Col md={12} xs={24}>
          <div className={styles['content']}>
            <img alt="Backcourt Logo" src={bannerWhite} width="60%" />
            <h1 className={styles['info-header']}>
              {t('marketing_texts.login')}
            </h1>
          </div>
        </Col>
        <Col md={12} xs={24}>
          <div className={styles['content']}>
            <div className={styles['login-panel']}>
              <h3>{t('login')}</h3>
              <CustomForm
                fields={fields}
                onSubmit={(values) => handleLogin(values)}
                loading={stateUser.loginStatus === LoadingStatus.LOADING}
                submitButtonText="login"
              />
              <Link to="/forgotPassword">{t('questions.forgot_password')}</Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default LoginPage;
